import React from "react";
import { Head as BaseHead } from "../../../common/components/Head";
import { useTitle } from "../../helpers/useTitle";

const Head: React.FC = () => {
  const { metaTitle, metaDescription, noIndex } = useTitle();
  return <BaseHead title={metaTitle} description={metaDescription} noIndex={noIndex} />;
};

export { Head };
